/**
 * Created by lenovo on 2017/2/20.
 */
const zh_cn = {
    'email': '邮箱',
    'password': '初始密码',

    //ella
    'PermissionManagement':'权限管理',
    'Subsystem':'子系统',
    'SubsystemList':'子系统列表',
    'AddSubsystem':'添加子系统',
    'EditSubsystem':'编辑子系统',
    'DetailSubsystem':'查看子系统详情',
    'SubsystemName':'子系统名称',
    'SubsystemNumber':'子系统编号',
    'AccessPath':'访问路径',
    userTypeName : '用户类型名称',
    userType:'用户类型',
    extendedCoding : '扩展属性编码',
    extended:'扩展属性',
    extendedName :'扩展属性名称',
    defaultAttributeValue:'默认属性值',
    sendTime : '发送时间',
    systemType : '系统类型',
    systemName : '系统名称',
    versionNumber:'版本号',
    versionTime : '版本时间',
    download : '下载地址',


    StatisticalManagement:'统计管理',
    UserDistributionStatistics:'用户分布统计',
    UserInformationStatistics:'用户信息统计',
    StatisticsTime:'统计时间',

    CreatePermissions:'创建权限',
    CreateModel:'创建模型',
    level:'级别',
    subsystem:'所属子系统',


    //bump
    proAdd : '添加协议定义',
    proEdit:'编辑协议定义',
    proName : '协议名称',
    ModelCategory : '模型类别',
    proHead : '协议头',
    proFoot : '协议尾',
    proCheckName:'协议校验方式',
    proCheckStart:'协议校验开始位',
    proCheckEnd:'协议校验结束位',
    proDefinition:'协议定义',

    CategoryName : '类别名称',
    codePre:'前缀',
    pframework:'所属协议',
    meta:'所属模块',
    paramCode:'参数指令',
    paramName:'参数中文名称',
    paramNameEn : '参数英文名称',
    andvalue:'与运算值',
    targetMeta : '结果赋值模块',
    anCode:'命令编码',
    anName :'命令名称',
    anValue :'命令值',
    metaNames:'匹配模块',
    isSaveHis:'转存历史',
    hisMsgType:'消息类型',


    ProtocolParameter:'协议参数',
    ProtocolParameterList:'协议参数列表',
    ProtocolParameterAdd:'添加协议参数',
    ProtocolParameterEdit:'编辑协议参数',
    deviceManagement:'设备管理',
    DeviceOnlineInquiry:'设备在线查询',
    queryCriteria:'查询条件',
    organizationStructure:'组织结构',
    CreateOrganizationalStructures:'创建组织结构',
    TermOfValidity:'有效期',
    BasicConfiguration:'基础配置',
    Yes:'是',
    No:'否',
    CommandAnalysis:'命令解析',
    CommandAnalysisList:'命令解析列表',
    CommandAnalysisAdd:'添加命令解析',
    CommandAnalysisEdit:'编辑命令解析',
    ModelCreation:'模型创建',
    ModelCategoryList:'模型类别列表',
    ModelCategoryAdd:'添加模型类别',
    ModelCategoryEdit:'编辑模型类别',
    APPManagement:'APP管理',
    APPVersionsList:'APP版本列表',
    APPVersionsAdd:'添加APP版本',
    APPVersionsEdit:'编辑APP版本',
    managers:'管理员',
    managersList:'管理员列表',
    managersAdd:'添加管理员',
    managersEdit:'编辑管理员',
    managersDetail:'查看管理员信息',

    userTypeList : '用户类型列表',
    userTypeAdd : '添加用户类型',
    userTypeEdit : '编辑用户类型',

    extendedList:'扩展属性列表',



    // common

    IncompleteInformation:'信息未填写！',
    AuthorityAssignment:'权限分配',
    fullName:'姓名',
    'role':'角色',
    'oldPass':'原密码',
    'newPass':'新密码',
    'passAgain':'再次输入新密码',
    'pleaseSelect':'请选择',
    "time":"时间",
    "searchCondition": "搜索条件",
    "configuration": "配置",
    "info": "信息",
    "query": "查询",
    "view": "查看",
    "add": "添加",
    "edit": "编辑",
    "delete": "删除",
    'readyDelete':'确定删除？',
    'deleteNode':'确定删除节点',
    "remark": "备注",
    "operation": "操作",
    "background": "后台",
    "manage": "管理",
    "apply": "申请",
    "submit": "提交",
    "return": "返回",
    "success": "成功",
    "failure": "失败",
    "save": "保存",
    "unit": "元",
    "detail": "详情",
    "more": "更多",
    "contacts": "联系人",
    "name": "名称",
    "telephone": "电话",
    "contactTelephone": "联系电话",
    "createTime": "创建时间",
    "status": "状态",
    "address":"地址",
    "addressDetail":"详细地址",
    "operate":"操作",
    "disable":"禁用",
    "stop":'停用',
    "readyStop":"确定停用?",
    "readyDisable":"确定禁用?",
    "readyEnable":"确定启用?",
    "readyFreeze":"确定冻结账户?",
    "readyUnfreeze":"确定解冻账户?",
    "enable":"启用",
    "freeze":"冻结",
    "unfreeze":"解冻",
    "noneData":"没找到数据",
    "no":"编号",
    "IDCardNo":"身份证号",
    "invitationCode":"邀请码",
    "close":"关闭",
    "sure":"确定",
    "export":"导出",
    'noDataText':'没有找到数据',
    'firstPage':'首页',
    'lastPage':'尾页',
    'valid':'有效',
    'invalid':'无效',
    'prompt':'提示',
    "recovery":"恢复",
    "resetting":"重置",
    "resetPassword":"重置密码",
    "loginName":"登录账号",
    "systemConfirm":"系统确认",
    "AreYouSureDoThis":"确定执行此操作吗?",
    "":"",

    // dealer服务商
    'store': "网点",
    'check': "审核",
    'list': "列表",
    "recheck": "复审",
    "store_xx_info": "网点信息",
    "user_type": "用户类型",
    "dealer": "服务商",
    "addDealer": "添加服务商",
    "service": "服务",
    "rewardCode": "奖励代码",
    "finishRewardCondition": "完成奖励条件",
    "reward": "奖励",
    "type": "类别",
    "form": "类型",
    "order": "订单",
    "business_amount": "业务金额",
    "withdraw_deposit_flow_detail": "提现流水详情",
    "subordinate_name": "所属服务商",
    "flow_no": "流水号",
    "account": "账户",
    "flow": "流水",
    "business_no": "业务单号",
    "business_type": "业务类型",
    "bank_name": "银行名称",
    "bank_card_no": "银行卡号",
    "bank_card": "银行卡",
    "opening_bank": "开户行",
    "available_balance": "可用余额",

    // lease 租赁
    "activityList":"活动列表",
    "activityRuleList":"活动规则列表",
    'activityDetail':'查看活动详情',
    "activityManage":"奖惩管理",
    "activityName":"活动名称",
    "activityCode":"活动码",
    "activityState":"活动状态",
    'activityTime':'活动时间',
    "activityRuleName":"活动规则名称",
    "activityRuleCode":"活动规则码",
    "activityRuleState":"活动规则状态",
    'addActivity':'添加活动',
    'editActivity':'编辑活动',
    'addActivityRule':'添加活动规则',
    'editActivityRule':'编辑活动规则',
    'rewardActivity':'奖励活动',
    'rewardType':'奖励类型',
    'activityType':'活动类型',

    'couponList':'奖励券列表',

    'orderManage':'订单管理',
    'orderSearch':'订单查询',
    'returnUserDetail':'返回用户详情',
    'systemSettings':'系统设置',
    'publicSettings':"公共设置",
    'addPlan':'添加计费方案',
    'addDetailPlan':'新增计费明细信息',
    'editPlan':'编辑计费方案',
    'editDetailPlan':'编辑计费明细信息',
    'billingScheme':'计费方案',
    'planName':'方案名称',

    'userFeedback':'用户反馈',
    'setFeedback':'反馈问题设置',
    'feedbackList':'反馈问题列表',
    'addFeedback':'反馈问题添加',
    'editFeedback':'反馈问题编辑',

    'staffManagement':'员工管理',
    'staffAccountManage':'员工账户管理',
    'staffAccountList':"员工账户列表",
    'staffAdd':'员工添加',
    'staffEdit':'员工编辑',
    'roleManagement':'角色管理',
    'roleList':'角色列表',
    'roleName':'角色名称',
    'roleNo':'角色编号',
    'addRole':'添加角色',
    'editRole':'编辑角色',
    'roleDetail':'角色详情',

    'fundsManagement':'资金管理',
    'configAccount':'商家收款账户配置',
    'EditAlipayAccount':'编辑支付宝收款账户',
    'AddAlipayAccount':'添加支付宝收款账户',
    'DetailAlipayAccount':'支付宝收款账户详情',
    'AddWeChatPublicAccounts':'添加微信公众平台账户',
    'EditWeChatPublicAccounts':'编辑微信公众平台账户',
    'EditWeChatOpenAccount':'编辑微信开放平台账户',
    'AddWeChatOpenAccount':'添加微信开放平台账户',
    'EditIntergralAccount':'编辑钱包收款账户',
    'AddIntergralAccount':'添加钱包收款账户',

    "gmtStart" : '开始时间',
    'gmtEnd' : '结束时间',
    "vendorManage":"商户管理",
    "operator":"运营商",
    "operatorName":"运营商名称",
    "addOperator":" 添加运营商",
    "operatorStatus":" 运营状态",
    "directSales":" 是否直营",
    "openAccountTime":" 开户时间",
    "agent":"代理商",
    "userManage":"用户管理",
    "userList":"用户列表",
    "normalUser":"普通用户",
    "normalUserAdd":"添加普通用户",
    "normalUserEdit":"编辑普通用户",
    "normalUserDetail":"普通用户信息查看",

    "userDetail":"查看用户详情",
    "user":"用户",
    "addAgent":"添加代理商",
    "region":"区域",
    "addRegion":"添加区域",
    "regionManage":" 区域管理", 
    "regionList":" 区域列表",
    "regionName":" 区域名称",
    "regionNo":"区域编号",
    "chargeCase":" 计费方案",
    "hasParking":" 有固定停车点",
    "hasnotParking":" 无固定停车点",
    "regionInfoManage":" 区域信息管理",
    "regionInfo":" 区域信息",
    "queryRegion":"查看区域信息",
    "regionEdit":"编辑区域信息",
    "regionAdd":"添加区域",
    "regionCode":" 区域编码",
    "parkingManage":" 停车点管理",
    "parkingList":" 停车点列表",
    "addParking":" 添加停车点",
    "parkingName":" 停车点名称",
    "parkingNameAndCodeAndId":"停车点名称/编号/ID",
    "carNum":"额定车位数量",
    "maxCarNum":"最多停车数量",
    "parkingInfoManage":"停车点管理",
    "parkingInfo":"停车点信息",
    "parkingInfoAdd":"添加停车点信息",
    "parkingInfoEdit":"编辑停车点信息",
    "parkingInfoDetail":"查看停车点信息",
    "parkingCode":"停车点编码",
    "agreeMore":"允许超额停车",
    "notAgreeMore":"不允许超额停车",
    "registerTime":"注册时间",
    "deposit":"押金金额",
    "depositState":'押金状态',
    "point":"积分",
    'handleUser':'操作用户',
    "depositBalance":"押金余额",
    "walletBalance":"钱包余额",
    "userAccount":"用户账号",
    "queryOrder":"查看租车订单",
    "queryDeposit":"查看押金记录",
    "queryWallet":"查看钱包记录",
    "queryCoupon":"查看优惠券记录",
    "accountStatus":"账户状态",
    "disableAccount":"禁用账户",
    "enableAccount":"启用账户",
    "freezeFundAccount":"冻结资金账户",
    "unfreezeFundAccount":"解冻资金账户",
    "carNo":"车辆编号",
    "rentCarTime":"租车时间",
    "charge":"费用",
    "orderStatus":"订单状态",
    "payStatus":"支付状态",
    "orderNo":"订单号",
    "unread":"未读",
    "read":"已读",
    "fundFlow":"资金流水",
    "depositRecord":"押金记录",
    "depositRecordList":"押金记录列表",
    "depositRecordDetail":'押金记录详情',
    "userAccount":"用户账户",
    "payType":"支付类型",
    "businessTime":"交易时间",
    "actTime":"动作类型",
    "depositRecharge":"押金充值(元)",
    "depositWithdraw":"押金提现(元)",
    "depositIncome":"押金收入(元)",
    "depositRechargeTime":"押金充值次数",
    "depositWithdrawTime":"押金提现次数",
    "realName":"真实姓名",
    "businessStatus":"交易状态",
    "businessFlowNo":"交易流水号",
    "businessOrderNo":"业务订单号",
    "businessName":"业务名称",
    "thirdBusinessPayAccount":"第三方交易支付账户",
    "amount":"金额",
    "payChannel":'具体支付方式',
    "businessAmountType":"交易金额类型",
    "traderMoneyBefore":"支付人交易前可用钱包(元)",
    "traderMoneyAfter":"支付人交易后可用钱包(元)",
    'refundNo':'第三方交易退款唯一标识',
    "refundAmount":"第三方交易退款金额(元)",
    "refundReason":"第三方交易退款说明",
    "rewardAmount":"奖励金额(元)",
    "flowCreateTime":"流水创建时间",
    "tradeTime":"第三方交易时间",
    "refundTime":"第三方交易退款时间",
    "depositRecharge1":"押金充值",
    "depositWithdraw1":"押金提现",
    "walletRecord":"钱包记录",
    "walletRecordList":"钱包记录列表",
    "walletRecordDetail":"钱包记录详情",
    "withdrawType":"提现方式",
    "walletRecharge":"钱包充值(元)",
    "walletWithdraw":"钱包提现(元)",
    "walletRecharge1":"钱包充值",
    "walletWithdraw1":"钱包提现",
    "walletIncome":"钱包收入(元)",
    "walletRechargeTime":"钱包收入次数",
    "walletWithdrawTime":"钱包提现次数",
    "dblclickToDetail":"双击可查看详情!",
    "tradeFinishTime":"交易完成时间",
    "pointWithdraw":"积分提现",
    "applyTransferAmount":"申请转账金额(元)",
    "actualTransferAmount":"实际转账金额(元)",
    "receiverAccount":"收款方账户",
    "receiverRealName":"收款方真实姓名",
    "tradeCreateTime":"交易创建时间",
    "transferResult":"转账结果",
    "pointRecharge":"积分充值",
    "businessType":"交易方式",
    "belongDealer":"所属服务商",
    'businessInfo':'商户信息',
    'mchName':'商户名',
    'basicInfo':'基础信息',
    "belongOperator":"所属运营商",
    "belongAgent":"所属代理商",
    "regionNameAndId":"区域名称/ID",

    'OperatorsAlipay':'运营商支付宝账户配置',
    'OperatorsWxpay':'运营商微信账户配置',
    'OperatorsIntegral':'运营商钱包账户配置',
    'userTelephone':'用户号码',
    "settleCase":"结算情况",
    "settle":"结算",
    "belongRegion":"所属区域",
    "agentName":"代理商名称",
    'dealerName':'服务商名称',
    'belongParking':'所在停车点',
    'carStatus':'车辆状态',


    appIdPublic: '微信公众号appid',
    appIdOpen: '微信开放平台账号appid',
    mchIdWx :'微信商户号MchId',
    subKey:'子业务系统交互key',
    apiKey:'微信签名验证密钥',
    certNo : '证书编号',
    certExpired : '微信商户证书过期时间',
    cert :'微信商户证书',
    "caseName":"方案名称"

};
export default zh_cn;


// WEBPACK FOOTER //
// ./modules/utils/zh_CN.js